import styled from 'styled-components';
import { breakpoint } from 'styled-components-breakpoint';

export const SuccessContent = styled.div`
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.23) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  border-radius: 5px;
  border: 3px solid var(--light-blue);
  background-image: url('/pre-auth-bg.svg');
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 10px;
`;

export const SectionTitle = styled.span`
  color: var(--offer1-green);
  font-size: 48px;
  font-weight: bold;
  text-align: center;
  ${breakpoint('mobile', 'desktop')`
    font-size: 32px;
  `}
`;

export const SectionText = styled.p`
  font-size: 24px;
  color: var(--gray1);
  text-align: center;
  ${breakpoint('mobile', 'desktop')`
    font-size: 18px;
  `}
`;

export const SubText = styled.p`
  font-size: 12px;
  color: var(--gray1);
  text-align: center;
`;
